interface Policy {
  state: string;
  companyProductCd: string;
  applicationId: string;
}

export const PRE_AUTHORIZATION_TOKEN = (policy: Policy) => {
  return `query {
        preAuthorizationToken(
          applicationId: "${policy.applicationId}"
          input:{
            stateProvCd: "${policy.state}",
            companyProductCd: "${policy.companyProductCd}"
          }
        ) {
          preAuthorizationToken,
          preAuthorizationPublicKey
        }
      }`;
};
